import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
var SquareImageContainer = renderWithRef('SquareImageContainer', null, function (props, ref) {
  var classNames = new Set(['swan-square-image-container']);
  return /*#__PURE__*/React.createElement(RenderComp, {
    root: "div",
    forwardedRef: ref,
    classNames: classNames,
    props: props
  }, /*#__PURE__*/React.createElement("div", {
    className: "swan-square-image-container-inner"
  }, props.children));
});
export { SquareImageContainer };